import React from "react";

const Mustard = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Mustard</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className=" table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>RH-30 [Released in 09.04.1985]</strong>
              </td>
            </tr>
            <tr>
              <td>2 kgs per acre</td>
              <td>25th September to 15th October</td>
              <td>2-3</td>
              <td>135-140 days</td>
              <td>Gives good results on late sowing. Oil content about 39%.</td>
              <td>9-10 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>T-59(VARUNA) [Released in 02.02.1976]</strong>
              </td>
            </tr>
            <tr>
              <td>2 kgs per acre</td>
              <td>25th September to 15th October</td>
              <td>2-3</td>
              <td>145-150 days</td>
              <td>
                Suitable for all climatic conditions. Oil content about 39%.
              </td>
              <td>8-10 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>LAXMI [Released in 01.05.1997]</strong>
              </td>
            </tr>
            <tr>
              <td>2 kgs per acre</td>
              <td>25th September to 15th October</td>
              <td>2-3</td>
              <td>145 days</td>
              <td>Oil content about 40.4%.</td>
              <td>10 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>RGN-48 [Released in 25.04.2006]</strong>
              </td>
            </tr>
            <tr>
              <td>2 kgs per acre</td>
              <td>25th September to 15th October</td>
              <td>2-3</td>
              <td>138-187 days</td>
              <td>
                Plant height 160-175cm. Profuse tillering. Dark brown grain.
                Frost resistant. Suitable for rainfed area. Lodging resistant,
                non shattering pods resistant. Oil content about 40.62%.
              </td>
              <td>7 quintals per acre</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Mustard;
